import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { VALIDATION_ERROR_MESSAGE } from 'app/constants/admin/browse/home';
import { SecondarySolidButton, SecondaryTextButton } from '@bibliocommons/base-buttons';
import TextField from 'app/components/shared/TextField';

import { isValidUrl } from 'app/helpers/admin/browse';

import './EditorUrl.scss';

const ENTER_KEY_CODE = 13;

const EditorUrl = ({
  errorMessage: validationErrorMessage,
  invalidUrlMessage,
  isEnabled,
  isLoading,
  label,
  onCancel,
  onChange,
  url
}) => {
  const hasExistingUrl = Boolean(url);

  const [state, setState] = useState({
    editUrl: url,
    errorMessage: ''
  });

  useEffect(() => {
    if (!validationErrorMessage) {
      return;
    }

    setState(prevState => {
      return {
        ...prevState,
        errorMessage: validationErrorMessage
      };
    });
  }, [validationErrorMessage]);

  const handleUrlChange = newUrl => {
    setState(prevState => {
      return {
        ...prevState,
        editUrl: newUrl
      };
    });
  };

  const handleUrlSave = () => {
    const { editUrl } = state;

    if (isValidUrl(editUrl)) {
      onChange(editUrl);
    } else {
      setState(prevState => {
        return {
          ...prevState,
          errorMessage: invalidUrlMessage
        };
      });
    }
  };

  const handleUrlKeyPress = event => {
    const keyCode = event.keyCode || event.charCode;
    if (keyCode !== ENTER_KEY_CODE) {
      return;
    }

    event.preventDefault();
    handleUrlSave();
  };

  const instanceId = useRef(uniqueId('SectionEditorListTitles_'));

  const cancelButtonKey = `${instanceId}_CancelButton`;
  const saveButtonKey = `${instanceId}_SaveButton`;
  const urlInputId = `${instanceId}_UrlInput`;

  const { editUrl, errorMessage } = state;

  return (
    <div className="cp-admin-browse-home-editor-url">
      <TextField
        className="url-input"
        disabled={!isEnabled}
        errorMessage={errorMessage}
        id={urlInputId}
        label={label}
        onChange={handleUrlChange}
        onKeyPress={handleUrlKeyPress}
        type="text"
        value={editUrl}
      />
      <SecondarySolidButton
        className="action"
        dataKey={saveButtonKey}
        handleClick={handleUrlSave}
        isLoading={isLoading}
        type="button"
      >
        {hasExistingUrl ? 'Save' : 'Add'}
      </SecondarySolidButton>
      {hasExistingUrl && (
        <SecondaryTextButton className="action" dataKey={cancelButtonKey} handleClick={onCancel} type="button">
          Cancel
        </SecondaryTextButton>
      )}
    </div>
  );
};

EditorUrl.defaultProps = {
  errorMessage: '',
  invalidUrlMessage: VALIDATION_ERROR_MESSAGE.INVALID_URL,
  isEnabled: true,
  isLoading: false
};

EditorUrl.propTypes = {
  errorMessage: PropTypes.string,
  invalidUrlMessage: PropTypes.string,
  isEnabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired
};

export default EditorUrl;
